var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { display: "block" }, attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title.edit-button")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { sm: "12" } }, [
                _c("div", { staticClass: "pad" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: { selected: _vm.row.Vat == 0 },
                      on: {
                        click: function ($event) {
                          return _vm.changeVat(0)
                        },
                      },
                    },
                    [_vm._v("DIV 0%")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: { selected: _vm.row.Vat == 6 },
                      on: {
                        click: function ($event) {
                          return _vm.changeVat(6)
                        },
                      },
                    },
                    [_vm._v("DIV 6%")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: { selected: _vm.row.Vat == 12 },
                      on: {
                        click: function ($event) {
                          return _vm.changeVat(12)
                        },
                      },
                    },
                    [_vm._v("DIV 12%")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: { selected: _vm.row.Vat == 21 },
                      on: {
                        click: function ($event) {
                          return _vm.changeVat(21)
                        },
                      },
                    },
                    [_vm._v("DIV 21%")]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 2,
                      fancy: "",
                      label: _vm.$ct("label.amount"),
                    },
                    on: { change: _vm.recalculate },
                    model: {
                      value: _vm.row.TotalPriceIncVat,
                      callback: function ($$v) {
                        _vm.$set(_vm.row, "TotalPriceIncVat", $$v)
                      },
                      expression: "row.TotalPriceIncVat",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("label.description") },
                    model: {
                      value: _vm.row.ProductDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.row, "ProductDescription", $$v)
                      },
                      expression: "row.ProductDescription",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }